import { useState } from 'react'

interface CopyButtonProps {
  text: string
  className?: string
  showLabel?: boolean
}

function CopyButton({ text, className = '', showLabel = false }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (!text) return
    
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
      // Fallback for older browsers
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  if (showLabel) {
    return (
      <button
        onClick={handleCopy}
        disabled={!text}
        className={`fab ${className}`}
      >
        <span className="material-symbols-outlined text-[20px]">
          {copied ? 'check' : 'content_copy'}
        </span>
        <span>{copied ? 'Copied!' : 'Copy'}</span>
      </button>
    )
  }

  return (
    <button
      onClick={handleCopy}
      disabled={!text}
      className={`p-3 rounded-xl bg-white dark:bg-surface-dark border border-slate-200 dark:border-border-dark text-slate-600 dark:text-slate-300 hover:text-primary hover:border-primary/50 transition-all disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      <span className={`material-symbols-outlined text-[20px] ${copied ? 'text-green-500' : ''}`}>
        {copied ? 'check' : 'content_copy'}
      </span>
    </button>
  )
}

export default CopyButton
